// Generated by purs version 0.13.8
"use strict";
var $foreign = require("./foreign.js");
var Data_HeytingAlgebra = require("../Data.HeytingAlgebra/index.js");
var Data_String_Common = require("../Data.String.Common/index.js");
var Record = require("../Record/index.js");
var onboardingSlides = [ {
    text: "Opt to join the Customer Plus program when you purchase qualifying Brother PH products",
    image: $foreign.getStarted1
}, {
    text: "Wait for the email confirming your membership to Customer Plus",
    image: $foreign.getStarted2
}, {
    text: "Log into the Customer Plus rewards catalog site and avail of exciting deals!",
    image: $foreign.getStarted3
} ];
var buildConfig = Record.merge()()({
    coloredLogo: $foreign.coloredLogo,
    whiteLogo: $foreign.whiteLogo,
    onboardingSlides: onboardingSlides
})($foreign.commonBuildConfig);
var hasStoreLinks = Data_HeytingAlgebra.not(Data_HeytingAlgebra.heytingAlgebraFunction(Data_HeytingAlgebra.heytingAlgebraBoolean))(Data_String_Common["null"])(buildConfig.storeLinks.ios) || Data_HeytingAlgebra.not(Data_HeytingAlgebra.heytingAlgebraFunction(Data_HeytingAlgebra.heytingAlgebraBoolean))(Data_String_Common["null"])(buildConfig.storeLinks.android);
module.exports = {
    buildConfig: buildConfig,
    hasStoreLinks: hasStoreLinks
};
